import React, { useEffect, useState } from 'react';
import LinkifyBase from 'react-linkify';

import { useJiraContext } from 'src/services/jira';
import { useSession } from 'src/services/session';

import integration from 'src/lib/api/integration';

import ErrorMessage from 'src/views/components/ErrorMessage';

const Linkify = ({ ...props }) => (
  <LinkifyBase
    {...props}
    componentDecorator={(href, text, key) => <a href={href} key={key} target="_blank" rel="noopener noreferrer">{text}</a>}
  />
);

const OtherAccounts = () => {
  const { accountDomain, environment: { accountBaseUrl } } = useSession();
  const { context: { clientKey } } = useJiraContext();
  const [error, setError] = useState(null);
  const [value, setValue] = useState(null);

  useEffect(
    () => {
      if (!accountBaseUrl || !clientKey) return;
      integration
        .getOtherConnectedAccounts(accountBaseUrl, clientKey)
        .then(setValue)
        .catch(setError);
    }, [accountBaseUrl, clientKey]);

  if (!error && !value) return null;
  if (error) return <ErrorMessage error={['Can not load list of other connected accounts', error]}/>;
  let { accounts_mappings = [] } = value || {};
  const jira = [];
  const pagerDuty = [];

  accounts_mappings.forEach(m => {
    const {
      pagerduty: p = {},
      jira: j = {},
      id,
    } = m;

    if (`${p.account_base_url}`.toLowerCase() !== accountBaseUrl) {
      pagerDuty.push(<li key={pagerDuty.length}><Linkify>{`${p.account_base_url}`}</Linkify></li>);
    }

    if (j.client_key !== clientKey) {
      jira.push(<li key={jira.length}><Linkify>{
        j.browse_base_url
        || j.api_base_url
        || `Not configured, connection ID = ${id}, Jira Client Key = ${j.client_key}`
      }</Linkify></li>);
    }
  });

  if (jira.length === 0 && pagerDuty.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'space-between', marginTop: '70px' }}>
      <div>
        <h5>Other Jira Accounts, linked to {accountDomain} PagerDuty account</h5>
      Go to corresponding Jira to configure it
        <br/>
        <ul>
          {jira}
        </ul>
      </div>
      <div style={{ width: 40 }}/>
      <div>
        <h5>Other PagerDuty Accounts, linked to this Jira</h5>
      Login with corresponding PagerDuty account to configure it
        <br/>
        <ul>
          {pagerDuty}
        </ul>
      </div>
    </div>
  );
};

export default OtherAccounts;
